import man from './man.gif';
import woman from './woman.gif';

export { man, woman }



// WEBPACK FOOTER //
// ./src/img/th/index.js